import { render, staticRenderFns } from "./TciRecruit.vue?vue&type=template&id=0744dfd8"
import script from "./TciRecruit.vue?vue&type=script&lang=js"
export * from "./TciRecruit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports